module.exports = __webpack_public_path__ + "img/lab-1.84a0ea7d.png";